import React from 'react';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);

		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	render() {
		const { hasError } = this.state;
		const { children } = this.props;

		if (hasError) {
			return null;
		}

		return children;
	}
}

export default ErrorBoundary;
